<template>
    <div>
        <modal :show.sync="show" headerClasses="pb-0" :hide-footer="true">
            <div>
                <PreviewModal ref="preview_modal"></PreviewModal>
                <h3 slot="header" class="mb-3 font-weight-500">Solicitor</h3>
                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Select Lawyer">
                            <el-select
                                v-model="solicitorSelected"
                                placeholder="Select Lawyer"
                            >
                                <el-option
                                    class="select-primary"
                                    v-for="solicitor in solicitorList"
                                    :key="solicitor.id"
                                    :label="solicitor.name"
                                    :value="solicitor.id"
                                >
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" @click="submitQuotation">Submit</b-button>
                    </b-col>
                </b-row>
            </div>
        </modal>
    </div>
</template>
  
<script>
import Modal from "@/components/Modal"
import { Select, DatePicker,  Option, Collapse, CollapseItem } from 'element-ui'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    helperFunctionMixin
} from '@/assets/js/httpImports.js'
import { integer } from 'vee-validate/dist/rules'
import PreviewModal  from '@/components/Modal/PreviewModal'
import { useProductStore } from '@/stores/productStore'
import { mapState, mapActions } from 'pinia'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'

export default {
    props:{
        show_documents: Boolean,
        customer_id: integer,
        product_id: integer,
        product_type: String, // Changed from object to String
        selected_documents: {
          type: Array,
          default: () => [],
        },
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        PreviewModal,
        Modal,
        [DatePicker.name]: DatePicker,
        [Collapse.name]: Collapse,
        [Option.name]: Option,
        [CollapseItem.name]: CollapseItem,
        [Select.name]: Select,
    },
    computed: {
        show: {
            get() {
                return this.show_documents;
            },
            set(newVal) {
                this.$emit('update:show_documents', newVal);
            },
        },

        customerDocuments(){
            if(this.searchQuery === ''){
                return this.customer_documents
            }
            return this.customer_documents.filter((document) => {
                let search = this.searchQuery.toLowerCase()
                if(
                    document.original_filename.toLowerCase().includes(search) || 
                    (document.attachment_category && document.attachment_category.name.toLowerCase().includes(search))
                ){
                    return true
                }
                return false
            })
        }
    },

    mounted() {
        if (this.customer_id) {
            this.getCustomerAttachments();
        }
        this.lawyerList()
    },
    // watch: {
    //   selected_documents(newVal) {
    //       console.log('Updated Selected Documents:', newVal);
    //   }
    // },
    data() {
        return {
            date_picked: '',
            doc_check: '',
            activeNames:['1'],
            is_loading_submit: false,
            solicitorSelected: '',
            solicitorList: [],
        }
    },

    methods:{
        ...mapActions(useProductStore, ['submitSolicitorDocuments']),
        lawyerList() {
            axios.get(services.access_control + 'user_list_by_role/lawyer', { headers: getHeader() })
            .then(response => {
                this.solicitorList = response.data.data
            })
            .catch ( error => {
                this.errorFunction(error, "Showing Lawyer Listing failed: " + error.response.data.message) 
            });
        },
        getCustomerAttachments(){
            axios.get(services.customer + 'customer/' + this.customer_id +'/attachments.all', {headers: getHeader()})
                .then(res => {
                    this.customer_documents = res.data.data
                    for(let x = 0; x < this.customer_documents.length; x++){ 
                        const document = this.customer_documents[x]
                        document.display_filename = document.attachment_category ? 
                            document.attachment_category.name + ' - ' + document.original_filename : 
                            document.original_filename
                    }
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },

        async submitQuotation() {
          if (!this.solicitorSelected) {
        this.errorFunction(null, "Please select a lawyer.");
        return;
    }
    // Prepare the payload
    const emailData = {
        to: this.solicitorList.find(solicitor => solicitor.id === this.solicitorSelected)?.email, // Get selected lawyer's email
        subject: "Case Documents",
        content: `These are the documents of the case assigned to you, and this is the Case ID: ${this.product_id}`,
        attachments_ids: this.selected_documents.map(doc => doc.attachment_id) // Map document IDs
    };

    try {
        // Send API request
        const response = await axios.post(
            services.attachment + '/send-to-email',
            emailData,
            { headers: getHeader() }
        );

        // Handle success
        this.notifySuccess('<b>Email</b> - Sent Successfully.');
    } catch (error) {
        // Handle error
        this.errorFunction(error, "Failed to send email.");
        console.error('Error:', error);
    }
            this.$emit('close')
        }
    }
}

</script>